import axios, { CancelTokenSource } from 'axios'

const csrfTokenUrl = '/api/v1/auth/csrf/'
const logoutUrl = '/api/v1/logout/session/'
// App navigation and administration must share one pending logout transport.
let pendingLogout: CancelTokenSource | undefined

export function cancelPendingLogout() {
  pendingLogout?.cancel('A new authentication request superseded logout')
  pendingLogout = undefined
}

export function logout() {
  cancelPendingLogout()
  const controller = axios.CancelToken.source()
  pendingLogout = controller
  const config = { cancelToken: controller.token, timeout: 10000 }
  return axios
    .post(logoutUrl, undefined, config)
    .catch(async (error) => {
      if (error?.response?.status !== 403 || controller.token.reason) throw error
      // A stale CSRF cookie does not mean the server session has been invalidated.
      await axios.get(csrfTokenUrl, config)
      if (controller.token.reason) return
      return axios.post(logoutUrl, undefined, config)
    })
    .catch((error) => {
      if (!controller.token.reason) throw error
    })
    .finally(() => {
      if (pendingLogout === controller) pendingLogout = undefined
    })
}
